import { useQuery } from '@apollo/client';
import { UserResourceStatsDocument } from 'src/graphql/generated/graphql';

interface UseResourceStatsProps {
  skip?: boolean;
}

export const useResourceStats = (props?: UseResourceStatsProps) => {
  const { skip } = props || {};

  const { data, loading } = useQuery(UserResourceStatsDocument, {
    skip,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  return {
    data: data?.userResourceStats,
    loading,
  };
};
